import { Inject, Injectable, Renderer2, RendererFactory2 } from "@angular/core";
import { LinkDefinition } from "./link.service";
import { DOCUMENT } from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class AlternateLinkService {
  private readonly renderer: Renderer2;
  private readonly document: Document;

  constructor(rendererFactory: RendererFactory2, @Inject(DOCUMENT) document: any) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.document = document;
  }

  /**
   * Adds a new alternate link tag to the document head
   */
  addAlternateTag(tag: LinkDefinition, forceCreation = false): HTMLLinkElement {
    const selector = this.getAlternateSelector(tag);
    const existing = (selector && (this.document.head.querySelector(selector) as HTMLLinkElement)) || null;

    if (existing && !forceCreation) {
      return this.updateAlternateTag(tag);
    }

    const link = this.renderer.createElement('link') as HTMLLinkElement;
    this.setAlternateLinkProperties(link, tag);
    this.renderer.appendChild(this.document.head, link);
    return link;
  }

  private updateAlternateTag(tag: LinkDefinition): HTMLLinkElement {
    const selector = this.getAlternateSelector(tag);
    const link = (selector && (this.document.head.querySelector(selector) as HTMLLinkElement)) || null;
    
    if (tag.href && link) {
        this.renderer.setAttribute(link, 'href', tag.href);
        return link;
    }

    return this.addAlternateTag(tag, true);
  }

  clearAlternateLinks() {
    const existing = this.document.head.querySelectorAll('link[rel="alternate"]');
    existing.forEach(link => this.renderer.removeChild(this.document.head, link));
  }

  private getAlternateSelector(tag: LinkDefinition): string | null {
    if (tag.rel === 'alternate' && tag.hreflang) {
      return `link[rel="alternate"][hreflang="${tag.hreflang}"]`;
    }
    return null;
  }

  private setAlternateLinkProperties(link: HTMLLinkElement, tag: LinkDefinition): void {
    if (tag.rel) this.renderer.setAttribute(link, 'rel', tag.rel);
    if (tag.href) this.renderer.setAttribute(link, 'href', tag.href);
    if (tag.hreflang) this.renderer.setAttribute(link, 'hreflang', tag.hreflang);
  }

}
